import React from "react";
import TextField from "@mui/material/TextField";

interface SearchBoxProps {
  value: string;
  onChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  placeholder?: string;
}

const SearchBox: React.FC<SearchBoxProps> = ({ value, onChange, placeholder }) => {
  return (
    <div className="px-2 py-1">
      <TextField
        variant="standard"
        value={value}
        onChange={onChange}
        placeholder={placeholder || "Type to search the table..."}
        fullWidth
        sx={{
          '& .MuiInputBase-input': {
            fontSize: '12px',
          },
        }}
      />
    </div>
  );
};

export default SearchBox;
